import { ConfigProvider } from 'antd'
import { ConfigProvider as MobileConfigProvider } from 'antd-mobile'
import enUS from 'antd-mobile/es/locales/en-US'
import { useEffect } from 'react'
import { Provider } from 'react-redux'
import { RouterProvider } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { Keyboard } from '@capacitor/keyboard'

import { store } from 'src/store/configureStore'
import { initGA } from 'src/utils/analytics'
import { isIOS } from 'src/utils/capacitor'
import { ChunkErrorBoundary } from 'src/utils/ChunkErrorBoundary'

import { router } from './routes'
import { themeConfig } from './styles/theme'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 10, // 10 minutes
      retry: 3,
      refetchOnWindowFocus: false,
    },
  },
})

const App = () => {
  // Initialize Google Analytics on app startup
  useEffect(() => {
    initGA()
  }, [])

  // Disable iOS WebView's automatic scroll-into-view on input focus.
  // Chat layout uses visualViewport + padding to position input above keyboard;
  // native scroll would stack on top and cause double-shift.
  useEffect(() => {
    if (isIOS()) {
      void Keyboard.setScroll({ isDisabled: true })
    }
  }, [])

  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <ConfigProvider theme={themeConfig}>
          <MobileConfigProvider locale={enUS}>
            <ChunkErrorBoundary>
              <RouterProvider router={router} />
            </ChunkErrorBoundary>
          </MobileConfigProvider>
        </ConfigProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </Provider>
  )
}

export default App
